export const getV3dInstance = () => window.v3d;
